<div class="container">
  <div class="heading-line">
    <h1>{{viewMode === viewModes.LESSONS ? 'Lessons Schedule' : 'Courses'}}</h1>
    <button
      type="button"
      class="btn btn-default report-button"
      (click)="changeViewMode()"
    >
      {{viewMode === viewModes.COURSES ? 'Lessons Schedule' : 'Courses'}}
    </button>
  </div>
  <ng-container *ngIf="viewMode === viewModes.LESSONS; else courses">
    <div class="button-group-container">
      <div class="btn-group">
        <label class="btn btn-primary" [(ngModel)]="radioModel"
               btnRadio="byTeacher" tabindex="0" role="button">By Teacher</label>
        <label class="btn btn-primary" [(ngModel)]="radioModel"
               btnRadio="byDate" tabindex="0" role="button">By Date</label>
      </div>
    </div>
    <ng-container *ngIf="radioModel === 'byDate'; else byTeacherTemplate">
      <div class="schedule-date-ranges">
        <input type="date" [(ngModel)]="startDate" (change)="setScheduleDates()">
        <input type="date" [(ngModel)]="endDate" (change)="setScheduleDates()">
        <button type="button" class="btn btn-default add-button" style="margin-right: auto"
                (click)="openEditModal(null, teachersGroup.controls.teacherId.value)">
          <i class="fas fa-plus"></i> Add new
        </button>
      </div>
      <app-schedule-calendar *ngIf="rooms && rawEvents.length"
        [lessonsSchedule]="lessonsScheduleByDates"
        [rawEvents]="rawEvents"
        [rooms]="rooms"
        [startDate]="dateStartDate"
        [endDate]="dateEndDate"
        [teachers]="teachers" [weekDates]="weekDates"
        (editLesson)="openEditModal($event.lesson, $event.teacherId)"
      />
    </ng-container>
    <ng-template #byTeacherTemplate>
      <form [formGroup]="teachersGroup">
        <div class="form-row">
          <div class="col-md-4 mb-3">
            <label for="teacherId">Select teacher:</label>
            <select id="teacherId" class="form-control" formControlName="teacherId">
              <option [ngValue]="null">Without teacher</option>
              <option *ngFor="let teacher of teachers"
                      [value]="teacher.id">
                {{ teacher.firstName + ' ' + teacher.lastName }}
              </option>
            </select>
          </div>
          <div class="col-md-4 mb-3">
            <button type="button" class="btn btn-default add-button" style="margin-right: auto"
                    (click)="openEditModal(null, teachersGroup.controls.teacherId.value)">
              <i class="fas fa-plus"></i> Add new
            </button>
          </div>
        </div>
      </form>

      <div class="user-list mt-3 mb-3 table-responsive" *ngIf="lessonSchedules && lessonSchedules.length > 0">
        <table class="table table-responsive-lg">
          <thead>
          <tr>
            <th class="text-center" scope="col">#</th>
            <th class="text-center" scope="col">Name</th>
            <th class="text-center" scope="col">Name Hebrew</th>
            <th class="text-center" scope="col">Start Date</th>
            <th class="text-center" scope="col">End Date</th>
            <th class="text-center" scope="col">Start Time</th>
            <th class="text-center" scope="col">End Time</th>
            <th class="text-center" scope="col">Day of the week</th>
            <th class="text-center" scope="col">Is Online</th>
            <th class="text-center" scope="col">Room</th>
            <th class="text-center" scope="col">Max Students</th>
            <th class="text-center" scope="col">Min Age</th>
            <th class="text-center" scope="col">Max Age</th>
            <th></th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let lesson of lessonSchedules">
            <td class="text-center">{{ lesson.id }}</td>
            <td class="text-center">{{ lesson.name }}</td>
            <td class="text-center">{{ lesson.nameHebrew }}</td>
            <td class="text-center">{{ lesson.startDate }}</td>
            <td class="text-center">{{ lesson.endDate }}</td>
            <td class="text-center">{{ lesson.startTime }}</td>
            <td class="text-center">{{ lesson.endTime }}</td>
            <td class="text-center">{{ lesson.dayOfWeek }}</td>
            <td class="text-center">{{ lesson.isOnline }}</td>
            <td class="text-center">{{ this.findRoomById(lesson.roomId)?.name || "none" }}</td>
            <td class="text-center">{{ lesson.maxStudents }}</td>
            <td class="text-center">{{ lesson.minAge }}</td>
            <td class="text-center">{{ lesson.maxAge }}</td>
            <td class="text-center">
              <button type="button" class="btn btn-light edit-button"
                      (click)="openEditModal(lesson, teachersGroup.controls.teacherId.value)">
                <i class="fas fa-pencil"></i>
              </button>
            </td>
            <td>
              <button type="button" class="btn btn-danger delete-button" (click)="openDeleteConfirmModal(lesson)">
                <i class="fas fa-trash"></i>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </ng-template>
  </ng-container>
  <ng-template #courses>
    <app-courses-list />
  </ng-template>

  <div *ngIf="errorMessage" class="alert alert-danger">
    {{ errorMessage }}
  </div>
</div>
